import * as React from "react";
import {DashboardNavbar} from "./DashboardNavbar";
import {IApplicationGuard, lazyInject, TypeDefs} from "@athena-portal/core";
import {TrustPilotFeedbackDialog} from "../modals/TrustPilotFeedbackDialog";
import {ICacheManager, ICustomerPortalService, Types} from "@falcon/services";
import {WebChatPopUp} from "@falcon/plugin-falcon-journey";

export default class FalconHeader extends React.Component {

    @lazyInject(TypeDefs.ApplicationGuard)
    private applicationGuard: IApplicationGuard;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    public render() {
        const policyNumber = this.getPolicyNumberFromUrl();
        return (
            <React.Fragment>
                <div className="journey-bg min-h-450">
                    <div>
                        <img className="waves" src="/img/Flow-waves.svg" alt="Journey background waves"/>
                        <img className="clouds" src="/img/Flow-clouds.svg" alt="Journey background clouds"/>
                    </div>
                </div>
                <WebChatPopUp policyNumber={policyNumber}/>
                <DashboardNavbar logout={this.doLogout}/>
                {<TrustPilotFeedbackDialog/>}
            </React.Fragment>
        );
    }

    private doLogout = () => {
        this.customerPortalService.activateReviewRequests(this.getPolicyNumberFromUrl()).subscribe(() => {
            history.pushState({}, "", "/dashboard");
            window.sessionStorage.clear();
            this.cacheManager.clearAll();
            this.deleteCookie("registerUnauthenticated");
            const redirectUrl = "".concat(window.location.origin, "/dashboard");
            this.applicationGuard.logout({redirectUri : redirectUrl});
        });
    };

    private deleteCookie(name: string): void {
        const appBaseUrl = window.location.hostname;
        let domain;
        if (appBaseUrl.includes("athenapaas.com")) {
            domain = "athenapaas.com";
        } else {
            domain = appBaseUrl;
        }
        document.cookie = name + "=;path=/;domain=" + domain + ";expires=Thu, 01-Jan-1970 00:00:01 GMT";
    }

    private getPolicyNumberFromUrl(): string {
        const url = window.location.href.replace(/\/$/, '');
        return url.slice(url.lastIndexOf('/') + 1);
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation/FalconHeader.tsx